import { useNavigate } from 'react-router-dom';
import { ProfilePage, mapMeToProfileData } from '@practium/features/profile';
import { useGetMe, useGetPlanSummary } from '@practium/features/api';
import { useForBinding, useForBindingParams } from '@practium/features/forBinding';

export const ProfilePageClient = () => {
	const navigate = useNavigate();
	const { forBindingParams, isForBinding } = useForBindingParams();
	const { forBindingUser } = useForBinding();

	const { data: me, isLoading } = useGetMe(forBindingParams, { enabled: !isForBinding });
	const { data: summary, isLoading: isSummaryLoading } = useGetPlanSummary(!isForBinding);

	const profileUser = isForBinding ? forBindingUser : me;
	const isProfileLoading = isForBinding ? !forBindingUser : isLoading || isSummaryLoading;
	const mapped = profileUser ? mapMeToProfileData(profileUser) : null;
	const data = mapped
		? {
				...mapped,
				plan: {
					...mapped.plan,
					name: summary?.plan?.name ?? mapped.plan.name,
					description: summary?.plan?.description ?? mapped.plan.description,
					validUntil: summary?.expiresIn
						? new Date(summary.expiresIn).toLocaleDateString('pt-BR')
						: mapped.plan.validUntil,
					canUpgrade: Boolean(summary?.canUpgrade),
					upgradePlanName: summary?.upgradePlanName ?? undefined,
				},
			}
		: null;

	const handleModify = () => {
		navigate('/perfil/editar');
	};

	return (
		<ProfilePage
			data={data}
			isLoading={isProfileLoading}
			onModify={handleModify}
			onUpgrade={() => navigate('/checkout/plano?upgrade=1')}
		/>
	);
};
